import React from 'react';
import styles from "./HeaderPartnerInfo.module.css";
import { Trans, useTranslation } from 'react-i18next';
     
const HeaderPartnerInfo = () => {
    const { t } = useTranslation();

    return (   
     <section className={styles['headerInfo-section']}>
        <p className={styles['headerInfo-description']}>
          <Trans i18nKey="partnerInfo.description" 
            components={{
              linkKiz: <a href="https://kiz.dance/" target="_blank" rel="noopener noreferrer" className={styles.headerInfo__link} />,
              br: <br />,
              highlight: <span className={styles.headerInfo__highlight} />
          }}
        />
        </p>
      </section>
    );
};

export default HeaderPartnerInfo;